module.exports = __webpack_public_path__ + "static/logo-4eaca3530fbe077fa0f251fa917d3df5.png";